import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { PreOrderListModel } from '../models/models'

export class DeletePreOrderReferenceApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/preOrder/deletePreOrder',
      requesterInfo,
    })
  }

  public async deleteOrder(request: any): Promise<any> {
    return await this.postAsync<any>(JSON.stringify(request))
  }
}
